// eslint-disable-next-line no-shadow
export enum DataModificationMethod {
  Delete = 'delete',
  Edit = 'edit',
  Create = 'create'
}
